import React from "react";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";

function PriceDisplay({ price, originalPrice, discountApplied, title = "Monatlicher Preis:" }) {
  return (
    <>
      {discountApplied ? (
        <>
          <div>
            <SoftTypography variant="h5" fontWeight="bold" color="dark">
              {title}
            </SoftTypography>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
              <span style={{ textDecoration: 'line-through', color: '#666', marginRight: '10px', fontSize: '1.1rem' }}>
                {originalPrice.toFixed(2)} €
              </span>
              <span style={{ color: '#8b0000', fontWeight: 'bold', fontSize: '1.3rem' }}>
                {price.toFixed(2)} € (20% Partner-Rabatt)
              </span>
            </div>
          </div>
        </>
      ) : (
        <SoftTypography variant="h5" fontWeight="bold" color="dark">
          {title} {price.toFixed(2)} €
        </SoftTypography>
      )}
    </>
  );
}

PriceDisplay.propTypes = {
  price: PropTypes.number.isRequired,
  originalPrice: PropTypes.number,
  discountApplied: PropTypes.bool,
  title: PropTypes.string
};

PriceDisplay.defaultProps = {
  originalPrice: null,
  discountApplied: false,
  title: "Monatlicher Preis:"
};

export default PriceDisplay;